import { BBadge } from './badge';
import { pluginFactory } from '../../utils/plugins';
var BadgePlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BBadge: BBadge
  }
});
export { BadgePlugin, BBadge };
export default BadgePlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/badge/index.js
// module id = 8Vb9
// module chunks = 21